import { BrowserRouter, HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Router from './routes';
import ThemeProvider from './theme';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route } from 'react-router-dom';
import { initializeIcons } from '@fluentui/react';

import './index.css';
import '../src/css/globalstyle.css'

import Layout from './pages/layout/Layout';
import Login from './pages/login/Login';
import useToken from './pages/login/useToken';
import useMsalAuth from './hooks/use-msal-auth';
// import { PersistGate } from "redux-persist/integration/react";
// import { Provider } from "react-redux";
// import { store, persistor } from "./store/index";

initializeIcons();

/**
 * The root component of the application.
 * Renders different routes based on the user's authentication status.
 */
export default function App() {
  const { token, setToken } = useToken();

  const { getUserProfile } = useMsalAuth();

  useEffect(() => {
    console.log("here 000");

    getUserProfile();
  }, [])
  useEffect(() => {
    if (window.location.hash.startsWith('#access_token=')) {
      window.location.hash = '#/';
    }
  }, []);

  if (!token) {
    // Render login routes if the user is not authenticated
    return (
      <HelmetProvider>
        <HashRouter>
          <ThemeProvider>
            <Routes>
              <Route path="/" element={<Layout />} />
              <Route index element={<Login setToken={setToken} />} />
              <Route path="*" element={<Login setToken={setToken} />} />
            </Routes>
          </ThemeProvider>
        </HashRouter>
      </HelmetProvider>
    );
  }

  // Render authenticated routes if the user is authenticated
  return (
    // <Provider store={store}>
    //   <PersistGate loading={null} persistor={persistor}>
    <HelmetProvider>
      <HashRouter>
        <ThemeProvider>
          <ScrollToTop />
          <StyledChart />
          <Router />
        </ThemeProvider>
      </HashRouter>
    </HelmetProvider>
    // </PersistGate>
    // </Provider>
  );
}

// ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
